/* Folliva "Soft Clinical": headings appear word by word when they scroll into view (same feel as the quiz).
   Skips the quiz itself (.flq), respects reduced motion, never hides text if anything fails. */
(function () {
  if (!('IntersectionObserver' in window)) return;
  if (window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var SEL = '.fl-display, .fl-head__title, .fl-hr-title';
  var PUNCT = /^[.,;:!?…)\]"”’»]+$/;
  function split(el) {
    var i = 0;
    (function walk(node) {
      Array.prototype.slice.call(node.childNodes).forEach(function (ch) {
        if (ch.nodeType === 3) {
          var parts = ch.textContent.split(/(\s+)/), frag = document.createDocumentFragment();
          parts.forEach(function (p) {
            if (!p) return;
            if (/^\s+$/.test(p)) { frag.appendChild(document.createTextNode(p)); return; }
            var sp = document.createElement('span');
            sp.className = PUNCT.test(p) ? 'fls-w fls-p' : 'fls-w';
            sp.style.setProperty('--d', (i * 70) + 'ms'); sp.textContent = p;
            frag.appendChild(sp); i++;
          });
          node.replaceChild(frag, ch);
        } else if (ch.nodeType === 1 && !/^(SVG|IMG|BR)$/i.test(ch.tagName)) walk(ch);
      });
    })(el);
    return i;
  }
  function init() {
    var els = Array.prototype.filter.call(document.querySelectorAll(SEL), function (el) {
      return !el.closest('.flq') && !el.closest('[data-fls-skip]') && !el.classList.contains('fls-words') && (el.textContent || '').trim().length < 160;
    });
    if (!els.length) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.1 });
    els.forEach(function (el) {
      try { if (split(el)) { el.classList.add('fls-words'); io.observe(el); } } catch (e) { el.classList.add('is-in'); }
    });
    /* safety: whatever happens, text is visible after 4 s */
    setTimeout(function () { els.forEach(function (el) { el.classList.add('is-in'); }); }, 4000);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  /* theme editor re-renders sections */
  document.addEventListener('shopify:section:load', function () { setTimeout(init, 50); });
})();
